export var NAME = 'authentication';
export var QR_CODE_REQUESTED = "".concat(NAME, "/QR_CODE_REQUESTED");
export var QR_CODE_RETRIEVED = "".concat(NAME, "/QR_CODE_RETRIEVED");
export var USER_LOGIN_ATTEMPT_COMPLETED = "".concat(NAME, "/USER_LOGIN_ATTEMPT_COMPLETED");
export var USER_LOGIN_REQUESTED = "".concat(NAME, "/USER_LOGIN_REQUESTED");
export var USER_PASSWORD_RESET_REQUEST_COMPLETED = "".concat(NAME, "/USER_PASSWORD_RESET_REQUEST_COMPLETED");
export var USER_PASSWORD_RESET_REQUESTED = "".concat(NAME, "/USER_PASSWORD_RESET_REQUESTED");
export var USER_REGISTRATION_REQUEST_FAILED = "".concat(NAME, "/USER_REGISTRATION_REQUEST_FAILED");
export var USER_REGISTRATION_REQUESTED = "".concat(NAME, "/USER_REGISTRATION_REQUESTED");
export var USER_RESET_PASSWORD_REQUEST_COMPLETED = "".concat(NAME, "/USER_RESET_PASSWORD_REQUEST_COMPLETED");
export var USER_RESET_PASSWORD_REQUESTED = "".concat(NAME, "/USER_RESET_PASSWORD_REQUESTED");
export var WECHAT_REDIRECT_RECEIVED = "".concat(NAME, "/WECHAT_REDIRECT_RECEIVED");